<template>
  <div class="nav-account">
    <div v-if="!login">
      <a class="nav-account-login" @click="loginHandler()">登录</a>
      <a class="nav-account-reg" @click="trialHandler()">试用</a>
      <trialDialog
        :dialogVisible="dialogVisible"
        @onCancel="onCancel"
        @singleHandler="singleHandler"
        @companyHandler="companyHandler"
        :dialogTitle="dialogTitle"
      ></trialDialog>
      <confirmDialog
        :dialogVisible="confirmVisible"
        dialogTitle="提示"
        @onCancel="onConfirmCancel"
      ></confirmDialog>
    </div>
    <div class="login-box" v-if="login">
      <el-dropdown placement="bottom-end" @command="logoutHandler">
        <span class="el-dropdown-link">
          <i class="iconfont icondingbudaohang-zhangh"></i>
          <span class="mobile" v-html="info.mobile"></span>
          <i class="iconfont iconxiala"></i>
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item command="console">控制台</el-dropdown-item>
          <el-dropdown-item command="logout">退出</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
  </div>
</template>

<script>
import trialDialog from '@/components/dialog/trial-dialog'
import confirmDialog from '@/components/dialog/confirm-dialog'
export default {
  components: { trialDialog, confirmDialog },
  data() {
    return {
      dialogVisible: false,
      dialogTitle: '',

      login: false,
      info: {},
      confirmVisible: false,
    }
  },
  computed: {
    loginStatus() {
      return this.$store.state.app.login //需要监听的数据
    },
  },
  watch: {
    loginStatus(newVal, oldVal) {
      this.login = newVal
      this.judgeLogin()
    },
  },
  mounted() {
    this.login = this.$store.state.app.login
    this.judgeLogin()
    this.$bus.on('compRegisterChoose', this.trialHandler)
    this.$bus.on('compRegisterChoose2', this.trialHandler2)
  },
  methods: {
    judgeLogin() {
      let token = this.$cookies.get('hr_token')
      if (token) {
        this.info = token
        this.$store.dispatch('setLogin', true)
      } else {
        this.$store.dispatch('setLogin', false)
      }
    },
    singleHandler() {
      this.dialogVisible = false
      this.confirmVisible = true
    },
    companyHandler() {
      this.$router.push({ path: '/register' })
      document.title =
        '试用 - 【赛码网】在线考试系统、在线面试系统-易用稳定专业'
    },
    loginHandler() {
      this.$router.push({ path: '/login' })
    },
    trialHandler() {
      let token = this.$cookies.get('hr_token')
      if (token) {
        if (token.finish == 0) {
          this.$router.push({ path: '/register/compInfo' })
          return
        }
        window.open('https://kao.acmcoder.com/b/')
        return
      }
      if (this.$cookies.get('role')) {
        this.companyHandler()
      }
      this.dialogVisible = true
    },
    trialHandler2() {
      let token = this.$cookies.get('hr_token')
      if (token) {
        if (token.finish == 0) {
          this.$router.push({ path: '/register/compInfo' })
          return
        }
        window.open('https://kao.acmcoder.com/m/')
        return
      }
      if (this.$cookies.get('role')) {
        this.companyHandler()
      }
      this.dialogVisible = true
    },
    logoutHandler(command) {
      if (command == 'logout') {
        this.$store.dispatch('setLogin', false)
        this.$cookies.remove('hr_token')
        this.$cookies.remove('client_token')
        this.$cookies.remove('kao_token', '/', 'acmcoder.com')
        this.logOutFromSys()
      } else if (command == 'console') {
        if (this.info.finish == 0) {
          this.$message.warning('请先完善企业信息！')
          this.$router.push({ path: '/register/compInfo' })
        } else {
          window.open('https://kao.acmcoder.com/b/')
        }
      }
    },
    logOutFromSys() {
      this.$axios
        .get('https://kao.acmcoder.com/enterprise/dropOut ')
        .then((res) => {
          if (res.data.code == 0) {
            this.$message.success('退出成功！')
          } else {
            this.$message.error(res.data.message)
          }
        })
    },
    onConfirmCancel() {
      this.confirmVisible = false
    },
    onCancel() {
      this.dialogVisible = false
    },
  },
}
</script>

<style lang="scss" scoped>
.nav-account {
  color: #666;
  line-height: 24px;
  float: right;
  padding: 2px 0;
  margin: 15px 10px 0 10px;
  white-space: nowrap;
  .login-box {
    min-width: 143px;
    line-height: 24px;
    cursor: pointer;
    i {
      font-size: 24px;
    }
    .mobile {
      font-size: 12px;
      position: relative;
      top: -4px;
    }
  }
  a {
    cursor: pointer;
  }
  .nav-account-login {
    padding: 0 3px 0 20px;
    color: #29bdb9;
  }

  .nav-account-reg {
    padding: 4px 15px;
    background: rgb(41, 189, 185);
    border-radius: 20px;
  }

  a {
    display: inline-block;
    color: #fff;
    font-size: 14px;
    text-decoration: none;
  }
}
</style>
<style lang="scss">
.el-dropdown-menu {
  text-align: center;
  width: 120.5px;
  border: 0;
  border-radius: 0 !important;
  border-top: 4px solid #29bdb9 !important;
  padding: 0 !important;
}
.el-dropdown-menu__item:not(.is-disabled):hover {
  background-color: #29bdb9 !important;
  text-align: center;
  width: 121px;
  border: 0;
  color: #fff !important;
  margin: -1px;
}
.el-popper .popper__arrow::after {
  content: none !important;
}
.el-popper .popper__arrow {
  border: 0 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/header/login/to-b.vue